// MEMASUKAN MODUL DARI REACT
import React from "react";
// MEMASUKAN MODUL DARI FRAMER MOTION
import { motion } from "framer-motion";
// MENGMASUKAN MODUL PENGHIAS YANG SAYA BUAT
import {
  LapisanWadah,
  MelenturkanWadah,
  Tajuk,
  TeksBiru,
  Tombol,
} from "../styles/Menyeluruh.styled";
import {
  KontakFormulir,
  LabelFormulir,
  MasukanFormulir,
} from "../styles/KontakSaya.styled";
import { PariasiHilangKeBawah } from "../utils/Pariasi";

const KontakSaya = () => {
  return (
    <LapisanWadah id="Kontak" atas="10%" bawah="10%">
      <Tajuk
        as={motion.h4}
        variants={PariasiHilangKeBawah}
        initial="hilang"
        whileInView="ada"
        ukuran="t4"
        luruskan="center"
      >
        My Contact
      </Tajuk>

      <Tajuk
        as={motion.h2}
        variants={PariasiHilangKeBawah}
        initial="hilang"
        whileInView="ada"
        ukuran="t2"
        atas="0.5rem"
        luruskan="center"
      >
        Contact <TeksBiru>Me Here</TeksBiru>
      </Tajuk>

      <LapisanWadah atas="3rem">
        <MelenturkanWadah benarkan="center">
          <KontakFormulir
            as={motion.form}
            variants={PariasiHilangKeBawah}
            initial="hilang"
            whileInView="ada"
          >
            <LapisanWadah bawah="2rem">
              <LabelFormulir>Name:</LabelFormulir>
              <MasukanFormulir type="text" placeholder="Fill Your Name" />
            </LapisanWadah>

            <LapisanWadah bawah="2rem">
              <LabelFormulir>Email:</LabelFormulir>
              <MasukanFormulir type="email" placeholder="Fill Your Email" />
            </LapisanWadah>

            <LapisanWadah bawah="2rem">
              <LabelFormulir>Message:</LabelFormulir>
              <MasukanFormulir as="textarea" placeholder="Fill Your Message" />
            </LapisanWadah>

            <MelenturkanWadah benarkan="center" melenturkanResponsif>
              <Tombol>Send</Tombol>
            </MelenturkanWadah>
          </KontakFormulir>
        </MelenturkanWadah>
      </LapisanWadah>
    </LapisanWadah>
  );
};

export default KontakSaya;
